<template>
    <Modal ref="modalRef" width-class="max-w-3xl">
        <template #title>Sticker size guide</template>

        <WysiwygContent>
            <p class="text-lg">
                Having trouble envisioning how big you want your stickers to be?
                Here’s a handy guide showing a few popular standard-sized items
                to help you decide.
            </p>

            <div class="mt-6 flex flex-col gap-8 md:flex-row">
                <div class="flex-1">
                    <h4>Coffee Mug: 4”x 5”</h4>
                    <p class="mt-1 text-sm">
                        Your standard issue diner style coffee mugs are
                        approximately 4 inches tall by 5 inches wide (including
                        the handle).
                    </p>

                    <h4 class="mt-4">Tea Bag: 3”x 2”</h4>
                    <p class="mt-1 text-sm">
                        A typical tea bag is usually about 3 inches tall by 2
                        inches wide- when held in optimum steeping position.
                    </p>

                    <h4 class="mt-4">Marshmallow: 2” x 2”</h4>
                    <p class="mt-1 text-sm">
                        Perfectly puffed cubes, the average marshmallow measures
                        2 inches all around (pre-S’Mores, that is).
                    </p>
                </div>

                <div class="md:w-5/12">
                    <img
                        src="~/assets/images/stickers/stickers-size-guide.webp"
                        alt="stickers size guide"
                        class="mx-auto max-w-xs md:max-w-full"
                    />
                </div>
            </div>
        </WysiwygContent>
    </Modal>
</template>

<script setup lang="ts">
import Modal from '~/components/Modal.vue';

const modalRef = ref<InstanceType<typeof Modal> | null>(null);

const open = () => {
    modalRef.value?.open();
};

defineExpose({ open });
</script>
